import CryptoJS from 'crypto-js';
import fromPairs from 'lodash/fromPairs'
import sortBy from 'lodash/sortBy'
import toPairs from 'lodash/toPairs'

/**
 * hash md5 with crypto
 * @param data 
 * @returns 
 */
export const md5 = (data: any) => {
  return CryptoJS.MD5(data).toString();
}

/**
 * sign md5
 * @param data 
 * @returns 
 */
export const signMd5 = (data: any) => {
  if (!data) {
    return null
  }
  const sortedData = fromPairs(sortBy(toPairs(data), ([key, _]) => key))

  return md5(JSON.stringify(sortedData))
}